import RoiCalculator from 'src/common/components/HrCalculator/components/Context/RoiCalculator';
import { AppConfiguration } from '../lib/type';
import { ReactElement } from 'react-markdown/lib/react-markdown';
import jsondata from '../utils/json/staticdata.json';

export interface RoiCalculatortProps {
  /**
   * All the configuration for the map
   */
  configuration: AppConfiguration;
  jsondata: object;
}

const Telco = ({ configuration }: RoiCalculatortProps): ReactElement => {
  return (
    <div>
      <RoiCalculator configuration={configuration} jsondata={jsondata} />
    </div>
  );
};

export default Telco;
